import { useToast } from 'vue-toastification';

import { i18nConfig } from '@/utils/i18n';
const t = i18nConfig.global.t;

export const hasKeyValue = (array: unknown[], key: string, value: unknown) => {
  return array.some(obj => obj[key] === value);
};

export const errorHandler = (error: Error) => {
  if ('response' in error) {
    const status = error.response?.status;
    const toast = useToast();

    if (status === 422 && error.response.data?.errorCode === 'attachments_over_size_limit') {
      toast.error(t('errors.attachmentsOverSizeLimit'));
    }

    if (status >= 500 && status < 600) {
      toast.error(t('errors.generic'));
    }
  }

  if (import.meta.env.VITE_MODE !== 'production') {
    console.warn('Error occurred:', error);
  }
};
